import queryString from "query-string";

import {
    ADD_FEEDBACK_ACTIVITIES,
    ADD_FEEDBACK_COACHING,
    ADD_FEEDBACK_EXAMINATION,
    ADD_PROGRESS_ACTIVITY,
    APPROVE_SOCIAL_LEARNING,
    APPROVE_STRUCTURED_LEARNING,
    ASSIGN_PROJECT,
    BULK_APPROVED,
    BULK_APPROVED_LND,
    BULK_APPROVED_SOCIAL,
    COMPLETE_PROJECT_ACTIVITIES,
    COMPLETE_REVIEW,
    COMPLETE_REVIEW_SOCIAL,
    CREATE_COACHING,
    CREATE_COACHING_SCHEDULE,
    CREATE_PROJECT,
    CREATE_PROJECT_ACTIVITIES,
    CREATE_PROPOSSED,
    CREATE_SOCIAL_LEARNING,
    CREATE_STRUCTURED_LEARNING,
    CREATE_TRAINING_EVENT,
    DELETE_COACHING,
    DELETE_PROJECT_ACTIVITIES,
    DELETE_TRAINING_EVENT,
    DOWNLOAD_CERTIFICATE_STRUCTURED_LEARNING,
    EDIT_PROJECT_ACTIVITIES,
    EDIT_TRAINING_EVENT,
    ENROLL_TRAINING_EVENT,
    ENROLLED_SOCIAL_LEARNING,
    ENROLLED_STRUCTURED_LEARNING,
    GET_COACHING,
    GET_COACHING_DETAIL,
    GET_IDP_HR_SOCIAL,
    GET_IDP_HR_STRUCTURED,
    GET_IDP_MANAGER,
    GET_IDP_PERSONAL,
    GET_IN_REVIEW,
    GET_IN_REVIEW_SOCIAL,
    GET_MY_IDP_EXPERIENTIAL,
    GET_MY_IDP_SOCIAL,
    GET_MY_IDP_STRUCTURED,
    GET_PROJECT_USER,
    GET_PROJECT_USER_BY_NIK,
    GET_SOCIAL_BY_ID,
    GET_TRAINING_EVENT_EMP,
    GET_TRAINING_EVENT_HR,
    INIT_IDP_SOCIAL_LEARNING,
    INIT_IDP_STRUCTURED_LEARNING,
    SUBMIT_SOCIAL_LEARNING,
    SUBMIT_STRUCTURED_LEARNING,
    SUBMIT_SUMMARY,
    UPDATE_COACHING,
    UPDATE_PROJECT_STATUS,
    UPDATE_SCORE_SOCIAL_LEARNING,
    UPDATE_SCORE_STRUCTURED_LEARNING,
    UPLOAD_CERTIFICATE_STRUCTURED_LEARNING,
    UPLOAD_PRESENTATION_SOCIAL_LEARNING
} from "@/api/myidp/myidp";

const state = {
    idpStructuredLearning: [],
    idpSocialLearning: [],
    idpExperientialLearning: [],
    progressActivity: [],
    feedbackCoaching: [],
    feedbackActivities: [],
    feedbackExamination: [],
    // Structured Learning
    idpPersonal: [],
    idpManager: [],
    idpHrStructured: [],
    idpHrSocial: [],
    masterCoaching: [],
    idpStructuredLearning: [],
    createStructuredLearning: [],
    createSocialLearning: [],
    enrolledStructuredLearning: [],
    submitStructuredLearning: [],
    approveStructuredLearning: [],
    uploadCertificateStructuredLearning: [],
    uploadPresentationSocialLearning: [],
    downloadCertificateStructuredLearning: [],
    updateScoreStructuredLearning: [],
    updateScoreSocialLearning: [],
    // Social Learning
    idpSocialLearning: [],
    submitSocialLearning: [],
    approveSocialLearning: [],
    enrolledSocialLearning: [],
    createProject: [],
    createPropossed: [],
    createProjectActivities: [],
    editProjectActivities: [],
    deleteProjectActivities: [],
    assignProject: [],
    projectUser: [],
    projectUserByNik: [],
    trainingEventHr: [],
    trainingEventEmp: [],
    createTrainingEvent: [],
    enrollTrainingEvent: [],
    idpReview: [],
    socialReview: [],
    completeReview: [],
    completeReviewSocial: [],
    coaching: [],
    coachingDetail: null,
    coachingSchedule: [],
    getSocialById: [],
    summary: [],

};

const mutations = {
    setProgress: (states, payload) => {
        states.progressActivity = payload
    },
    setSummary: (states, payload) => {
        states.summary = payload
    },
    setSocialById: (states, payload) => {
        states.getSocialById = payload
    },
    setCoachingSchedule: (states, payload) => {
        states.coachingSchedule = payload
    },
    setMasterCoaching: (states, payload) => {
        states.masterCoaching = payload
    },
    setCoaching: (states, payload) => {
        states.coaching = payload
    },
    setCoachingDetail: (states, payload) => {
        states.coachingDetail = payload
    },
    setFeedbackCoaching: (states, payload) => {
        states.feedbackCoaching = payload
    },
    setFeedback: (states, payload) => {
        states.feedbackActivities = payload
    },
    setFeedbackExamination: (states, payload) => {
        states.feedbackExamination = payload
    },
    //New My IDP
    setMyStructured: (states, payload) => {
        states.idpStructuredLearning = payload;
    },
    setMySocial: (states, payload) => {
        states.idpSocialLearning = payload;
    },
    setMyExperiential: (states, payload) => {
        states.idpExperientialLearning = payload;
    },
    // Structured Learning
    setIdp: (states, payload) => {
        states.idpPersonal = payload;
    },
    setIdpManager: (states, payload) => {
        states.idpManager = payload;
    },
    setIdpHrStructured: (states, payload) => {
        states.idpHrStructured = payload;
    },
    setIdpHrSocial: (states, payload) => {
        states.idpHrSocial = payload;
    },
    setIdpStructuredLearning: (states, payload) => {
        states.idpStructuredLearning = payload
    },
    setCreateStructuredLearning: (states, payload) => {
        states.createStructuredLearning = payload
    },
    setCreateSocialLearning: (states, payload) => {
        states.createSocialLearning = payload
    },
    setEnrolledStructuredLearning: (states, payload) => {
        states.enrolledStructuredLearning = payload
    },
    setSubmitStructuredLearning: (states, payload) => {
        states.submitStructuredLearning = payload
    },
    setApproveStructuredLearning: (states, payload) => {
        states.approveStructuredLearning = payload
    },
    setUploadCertificateStructuredLearning: (states, payload) => {
        states.uploadCertificateStructuredLearning = payload
    },
    setUploadPresentationSocialLearning: (states, payload) => {
        states.uploadPresentationSocialLearning = payload
    },
    setDownloadCertificateStructuredLearning: (states, payload) => {
        states.downloadCertificateStructuredLearning = payload
    },
    setUpdateScoreStructuredLearning: (states, payload) => {
        states.updateScoreStructuredLearning = payload
    },
    setUpdateScoreSocialLearning: (states, payload) => {
        states.updateScoreSocialLearning = payload
    },
    // Social Learning
    setIdpSocialLearning: (states, payload) => {
        states.idpSocialLearning = payload
    },
    setSubmitSocialLearning: (states, payload) => {
        states.submitStructuredLearning = payload
    },
    setApproveSocialLearning: (states, payload) => {
        states.approveSocialLearning = payload
    },
    setEnrolledSocialLearning: (states, payload) => {
        states.enrolledSocialLearning = payload
    },
    setCreateProject: (states, payload) => {
        states.createProject = payload
    },
    setCreateProjectActivities: (states, payload) => {
        states.createProjectActivities = payload
    },
    setEditProjectActivities: (states, payload) => {
        states.editProjectActivities = payload
    },
    setDeleteProjectActivities: (states, payload) => {
        states.deleteProjectActivities = payload
    },
    setAssignProject: (states, payload) => {
        states.assignProject = payload
    },
    setProjectUser: (states, payload) => {
        states.projectUser = payload
    },
    setProjectUserByNik: (states, payload) => {
        states.projectUserByNik = payload
    },
    setEventByHr: (states, payload) => {
        states.trainingEventHr = payload
    },
    setEventByEmp: (states, payload) => {
        states.trainingEventEmp = payload
    },
    setCreateTrainingEvent: (states, payload) => {
        states.createTrainingEvent = payload
    },
    setEnrollTrainingEvent: (states, payload) => {
        states.enrollTrainingEvent = payload
    },
    setIdpReview: (states, payload) => {
        states.idpReview = payload
    },
    setReviewSocial: (states, payload) => {
        states.socialReview = payload
    },
    setCompleteReview: (states, payload) => {
        states.completeReview = payload
    },
    setCompleteReviewSocial: (states, payload) => {
        states.completeReviewSocial = payload
    },

    setCreatePropossed: (states, payload) => {
        states.createPropossed = payload
    },

};

const actions = {
    getCoaching: async ({ commit }, args) => {
        try {
            const resp = await GET_COACHING(args);
            if (resp.data.httpCode === 200) {
                commit("setMasterCoaching", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setMasterCoaching", []);
            }
            throw err;
        }
    },
    getCoachingDetail: async ({ commit }, id) => {
        try {
            const resp = await GET_COACHING_DETAIL(id);
            if (resp.data.httpCode === 200) {
                commit("setCoachingDetail", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setCoachingDetail", null);
            }
            throw err;
        }
    },
    // New My IDP
    getMyStructured: async ({ commit }, args = {}) => {
        try {
            const resp = await GET_MY_IDP_STRUCTURED(args);
            if (resp.data.httpCode === 200) {
                commit("setMyStructured", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setMyStructured", []);
            }
            throw err;
        }
    },
    getMySocial: async ({ commit }, args = {}) => {
        try {
            const resp = await GET_MY_IDP_SOCIAL(args);
            if (resp.data.httpCode === 200) {
                commit("setMySocial", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setMySocial", []);
            }
            throw err;
        }
    },
    getMyExperiential: async ({ commit }, args = {}) => {
        try {
            const resp = await GET_MY_IDP_EXPERIENTIAL(args);
            if (resp.data.httpCode === 200) {
                commit("setMyExperiential", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setMyExperiential", []);
            }
            throw err;
        }
    },
    // Structured Learning
    getIdpPersonal: async ({ commit }, args) => {
        const params = queryString.stringify(args);
        try {
            const resp = await GET_IDP_PERSONAL(params);
            if (resp.data.httpCode === 200) {
                commit("setIdp", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setIdp", []);
            }
            throw err;
        }
    },
    getIdpManager: async ({ commit }, args) => {
        const params = queryString.stringify(args);
        try {
            const resp = await GET_IDP_MANAGER(params);
            if (resp.data.httpCode === 200) {
                commit("setIdpManager", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setIdpManager", []);
            }
            throw err;
        }
    },
    getIdpHrStructured: async ({ commit }, args) => {
        const params = queryString.stringify(args);
        try {
            const resp = await GET_IDP_HR_STRUCTURED(params);
            if (resp.data.httpCode === 200) {
                commit("setIdpHrStructured", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setIdpHrStructured", []);
            }
            throw err;
        }
    },
    getIdpHrSocial: async ({ commit }, args) => {
        const params = queryString.stringify(args);
        try {
            const resp = await GET_IDP_HR_SOCIAL(params);
            if (resp.data.httpCode === 200) {
                commit("setIdpHrSocial", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setIdpHrSocial", []);
            }
            throw err;
        }
    },
    initIdpStructuredLearning: async ({ commit }, args) => {
        const params = queryString.stringify(args);
        try {
            const resp = await INIT_IDP_STRUCTURED_LEARNING(params);
            if (resp.data.httpCode === 200) {
                commit("setIdpStructuredLearning", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setIdpStructuredLearning", []);
            }
            throw err;
        }
    },
    createStructuredLearning: async ({ commit }, args) => {
        try {
            const resp = await CREATE_STRUCTURED_LEARNING(args);
            if (resp.data.httpCode === 200) {
                commit("setCreateStructuredLearning", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setCreateStructuredLearning", []);
            }
            throw err;
        }
    },
    addFeedback: async ({ commit }, args) => {
        try {
            const resp = await ADD_FEEDBACK_ACTIVITIES(args);
            if (resp.data.httpCode === 200) {
                commit("setFeedback", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setFeedback", []);
            }
            throw err;
        }
    },
    addFeedbackExamination: async ({ commit }, args) => {
        try {
            const resp = await ADD_FEEDBACK_EXAMINATION(args);
            if (resp.data.httpCode === 200) {
                commit("setFeedbackExamination", resp.data);
                return resp.data;
            }
        } catch (err) {
            if (err.response) {
                const resp = err.response;
                if (resp.data.httpCode === 404) {
                    commit("setFeedbackExamination", []);
                }
            } else {
                console.error("Unexpected error:", err);
            }
            throw err;
        }
    },
    addFeedbackCoaching: async ({ commit }, args) => {
        try {
            const resp = await ADD_FEEDBACK_COACHING(args);
            if (resp.data.httpCode === 200) {
                commit("setFeedbackCoaching", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setFeedbackCoaching", []);
            }
            throw err;
        }
    },
    addProgressActivity: async ({ commit }, args) => {
        try {
            const resp = await ADD_PROGRESS_ACTIVITY(args);
            if (resp.data.httpCode === 200) {
                commit("setProgress", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setProgress", []);
            }
            throw err;
        }
    },
    createSocialLearning: async ({ commit }, args) => {
        try {
            const resp = await CREATE_SOCIAL_LEARNING(args);
            if (resp.data.httpCode === 200) {
                commit("setCreateSocialLearning", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setCreateSocialLearning", []);
            }
            throw err;
        }
    },
    enrollStructuredLearning: async ({ commit }, args) => {
        try {
            const resp = await ENROLLED_STRUCTURED_LEARNING(args);
            if (resp.data.httpCode === 200) {
                commit("setEnrolledStructuredLearning", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setEnrolledStructuredLearning", []);
            }
            throw err;
        }
    },
    submitStructuredLearning: async ({ commit }, args) => {
        try {
            const resp = await SUBMIT_STRUCTURED_LEARNING(args);
            if (resp.data.httpCode === 200) {
                commit("setSubmitStructuredLearning", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setSubmitStructuredLearning", []);
            }
            throw err;
        }
    },
    approveStructuredLearning: async ({ commit }, args) => {
        try {
            const resp = await APPROVE_STRUCTURED_LEARNING(args);
            if (resp.data.httpCode === 200) {
                commit("setApproveStructuredLearning", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setApproveStructuredLearning", []);
            }
            throw err;
        }
    },
    uploadCertificateStructuredLearning: async ({ commit }, { id, file }) => {
        const formData = new FormData();
        formData.append('files', file);

        const resp = await UPLOAD_CERTIFICATE_STRUCTURED_LEARNING(formData, id);
        // console.log('tes:', resp
        // );
        if (resp.data.httpCode === 200) {
            commit("setUploadCertificateStructuredLearning", resp.data);
            return resp.data;

        } else if (resp.data.httpCode !== 200) {
            commit("setUploadCertificateStructuredLearning", []);
        }
        throw err;
    },
    uploadPresentationSocialLearning: async ({ commit }, { id, file }) => {
        const formData = new FormData();
        formData.append('files', file);

        const resp = await UPLOAD_PRESENTATION_SOCIAL_LEARNING(formData, id);
        // console.log('tes:', resp
        // );
        if (resp.data.httpCode === 200) {
            commit("setUploadPresentationSocialLearning", resp.data);
            return resp.data;

        } else if (resp.data.httpCode !== 200) {
            commit("setUploadPresentationSocialLearning", []);
        }
        throw err;
    },
    downloadCertificateStructuredLearning: async ({ commit }, args) => {
        try {
            const resp = await DOWNLOAD_CERTIFICATE_STRUCTURED_LEARNING(args);
            if (resp.data.httpCode === 200) {
                commit("setDownloadCertificateStructuredLearning", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setDownloadCertificateStructuredLearning", []);
            }
            throw err;
        }
    },
    updateScoreStructuredLearning: async ({ commit }, args) => {
        try {
            const resp = await UPDATE_SCORE_STRUCTURED_LEARNING(args);
            if (resp.data.httpCode === 200) {
                commit("setUpdateScoreStructuredLearning", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setUpdateScoreStructuredLearning", []);
            }
            throw err;
        }
    },
    updateScoreSocialLearning: async ({ commit }, args) => {
        try {
            const resp = await UPDATE_SCORE_SOCIAL_LEARNING(args);
            if (resp.data.httpCode === 200) {
                commit("setUpdateScoreSocialLearning", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setUpdateScoreSocialLearning", []);
            }
            throw err;
        }
    },

    // Social Learning
    initIdpSocialLearning: async ({ commit }, args) => {
        const params = queryString.stringify(args);
        try {
            const resp = await INIT_IDP_SOCIAL_LEARNING(params);
            if (resp.data.httpCode === 200) {
                commit("setIdpSocialLearning", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setIdpSocialLearning", []);
            }
            throw err;
        }
    },
    submitSocialLearning: async ({ commit }, args) => {
        try {
            const resp = await SUBMIT_SOCIAL_LEARNING(args);
            if (resp.data.httpCode === 200) {
                commit("setSubmitSocialLearning", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setSubmitSocialLearning", []);
            }
            throw err;
        }
    },
    approveSocialLearning: async ({ commit }, args) => {
        try {
            const resp = await APPROVE_SOCIAL_LEARNING(args);
            if (resp.data.httpCode === 200) {
                commit("setApproveSocialLearning", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setApproveSocialLearning", []);
            }
            throw err;
        }
    },
    enrollSocialLearning: async ({ commit }, args) => {
        try {
            const resp = await ENROLLED_SOCIAL_LEARNING(args);
            if (resp.data.httpCode === 200) {
                commit("setEnrolledSocialLearning", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setEnrolledSocialLearning", []);
            }
            throw err;
        }
    },
    createProject: async ({ commit }, formData) => {
        try {
            const resp = await CREATE_PROJECT(formData);
            if (resp.data.httpCode === 200) {
                commit("setCreateProject", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setCreateProject", []);
            }
            throw err;
        }
    },
    createSummary: async ({ commit }, formData) => {
        try {
            const resp = await SUBMIT_SUMMARY(formData);
            if (resp.data.httpCode === 200) {
                commit("setSummary", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp?.data?.httpCode === 404) {
                commit("setSummary", []);
            }
            throw err;
        }
    },
    createProjectActivities: async ({ commit }, args) => {
        try {
            const resp = await CREATE_PROJECT_ACTIVITIES(args);
            if (resp.data.httpCode === 200) {
                commit("setCreateProjectActivities", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setCreateProjectActivities", []);
            }
            throw err;
        }
    },
    editProjectActivities: async ({ }, { id, formData }) => {
        try {
            const response = await EDIT_PROJECT_ACTIVITIES(id, formData);
            return response;
        } catch (error) {
            throw error;
        }
    },
    updateProjectStatus: async ({ }, { id, status, notes }) => {
        try {
            const response = await UPDATE_PROJECT_STATUS(id, status, notes);
            return response;
        } catch (error) {
            throw error;
        }
    },
    deleteProjectActivities: async ({ }, id) => {
        return await DELETE_PROJECT_ACTIVITIES(id);
    },

    completeProjectActivities: async ({ }, id) => {
        return await COMPLETE_PROJECT_ACTIVITIES(id);
    },

    editTrainingEvent: async ({ }, args) => {
        return await EDIT_TRAINING_EVENT(args);
    },
    deleteTrainingEvent: async ({ }, id) => {
        return await DELETE_TRAINING_EVENT(id);
    },
    // editProjectActivities: async ({ commit }, {args}) => {
    //     try {
    //         const resp = await EDIT_PROJECT_ACTIVITIES(args);
    //         if (resp.data.httpCode === 200) {
    //             commit("setEditProjectActivities", resp.data);
    //             return resp.data;
    //         }
    //     } catch (err) {
    //         const resp = err.response;
    //         if (resp.data.httpCode === 404) {
    //             commit("setEditProjectActivities", []);
    //         }
    //         throw err;
    //     }
    // },
    // deleteProjectActivities: async ({ commit }, {args}) => {
    //     try {
    //         const resp = await DELETE_PROJECT_ACTIVITIES(args);
    //         if (resp.data.httpCode === 200) {
    //             commit("setDeleteProjectActivities", resp.data);
    //             return resp.data;
    //         }
    //     } catch (err) {
    //         const resp = err.response;
    //         if (resp.data.httpCode === 404) {
    //             commit("setDeleteProjectActivities", []);
    //         }
    //         throw err;
    //     }
    // },
    assignProject: async ({ commit }, args) => {
        try {
            const resp = await ASSIGN_PROJECT(args);
            if (resp.data.httpCode === 200) {
                commit("setAssignProject", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setAssignProject", []);
            }
            throw err;
        }
    },
    createCoaching: async ({ commit }, args) => {
        try {
            const resp = await CREATE_COACHING(args);
            if (resp.data.httpCode === 200) {
                commit("setCoaching", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setCoaching", []);
            }
            throw err;
        }
    },

    deleteCoaching: async ({ }, id) => {
        try {
            const resp = await DELETE_COACHING(id);
            return resp.data;
        } catch (err) {
            throw err;
        }
    },

    updateCoaching: async ({ }, { id, data }) => {
        try {
            const resp = await UPDATE_COACHING(id, data);
            return resp.data;
        } catch (err) {
            throw err;
        }
    },


    createCoachingSchedule: async ({ commit }, { id, args }) => {
        try {
            const resp = await CREATE_COACHING_SCHEDULE(id, args);
            if (resp.data.httpCode === 200) {
                commit("setCoachingSchedule", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setCoachingSchedule", []);
            }
            throw err;
        }
    },

    getSocialById: async ({ commit }, id) => {
        try {
            const resp = await GET_SOCIAL_BY_ID(id);
            if (resp.data.httpCode === 200) {
                commit("setSocialById", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setSocialById", []);
            }
            throw err;
        }
    },
    getProjectByUser: async ({ commit }, { id, args }) => {
        try {
            const resp = await GET_PROJECT_USER(id, args);
            if (resp.data.httpCode === 200) {
                commit("setProjectUser", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setProjectUser", []);
            }
            throw err;
        }
    },
    getProjectByNik: async ({ commit }, { nik, args }) => {
        try {
            const resp = await GET_PROJECT_USER_BY_NIK(nik, args);
            if (resp.data.httpCode === 200) {
                commit("setProjectUserByNik", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setProjectUserByNik", []);
            }
            throw err;
        }
    },
    getEventByHr: async ({ commit }, { id, args }) => {
        try {
            const resp = await GET_TRAINING_EVENT_HR(id, args);
            if (resp.data.httpCode === 200) {
                commit("setEventByHr", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setEventByHr", []);
            }
            throw err;
        }
    },
    getEventByEmp: async ({ commit }, { id, args }) => {
        try {
            const resp = await GET_TRAINING_EVENT_EMP(id, args);
            if (resp.data.httpCode === 200) {
                commit("setEventByEmp", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setEventByEmp", []);
            }
            throw err;
        }
    },
    createTrainingEvent: async ({ commit }, args) => {
        try {
            const resp = await CREATE_TRAINING_EVENT(args);
            if (resp.data.httpCode === 200) {
                commit("setCreateTrainingEvent", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setCreateTrainingEvent", []);
            }
            throw err;
        }
    },
    enrollTrainingEvent: async ({ commit }, args) => {
        try {
            const resp = await ENROLL_TRAINING_EVENT(args);
            if (resp.data.httpCode === 200) {
                commit("setEnrollTrainingEvent", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setEnrollTrainingEvent", []);
            }
            throw err;
        }
    },
    getIdpReview: async ({ commit }, args) => {
        const params = queryString.stringify(args);
        try {
            const resp = await GET_IN_REVIEW(params);
            if (resp.data.httpCode === 200) {
                commit("setIdpReview", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setIdpReview", []);
            }
            throw err;
        }
    },
    getReviewSocial: async ({ commit }, args) => {
        const params = queryString.stringify(args);
        try {
            const resp = await GET_IN_REVIEW_SOCIAL(params);
            if (resp.data.httpCode === 200) {
                commit("setReviewSocial", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setReviewSocial", []);
            }
            throw err;
        }
    },
    completeReview: async ({ }, id) => {
        return await COMPLETE_REVIEW(id);
    },
    bulkApproved: async ({ }, id) => {
        return await BULK_APPROVED(id);
    },
    bulkApprovedSocial: async ({ }, id) => {
        return await BULK_APPROVED_SOCIAL(id);
    },
    bulkApprovedLND: async ({ }, id) => {
        return await BULK_APPROVED_LND(id);
    },
    completeReviewSocial: async ({ }, id) => {
        return await COMPLETE_REVIEW_SOCIAL(id);
    },

    createPropossed: async ({ commit }, args) => {
        try {
            const resp = await CREATE_PROPOSSED(args);
            if (resp.data.httpCode === 200) {
                commit("setCreatePropossed", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setCreatePropossed", []);
            }
            throw err;
        }
    },
};

const getters = {
    // Structured Learning
    IdpPersonal: (states) => states.idpPersonal,
    IdpManager: (states) => states.idpManager,
    idpStructuredLearning: (states) => states.idpStructuredLearning,
    createStructuredLearning: (states) => states.createStructuredLearning,
    enrollStructuredLearning: (states) => states.enrollStructuredLearning,
    submitStructuredLearning: (states) => states.submitStructuredLearning,
    approveStructuredLearning: (states) => states.approveStructuredLearning,
    // Social Learning
    idpSocialLearning: (states) => states.idpSocialLearning,
    submitSocialLearning: (states) => states.submitSocialLearning,
    approveSocialLearning: (states) => states.approveSocialLearning
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};